import React from 'react'
import DocumentTitle from 'react-document-title'

export const withDocTitle = (
  WrappedComponent,
  title = 'HHS-OIG Hotline Operations'
) => {
  return class extends React.Component { //eslint-disable-line
    render() {
      return (
        <DocumentTitle title={this.props.docTitle || title}>
          <WrappedComponent {...this.props} />
        </DocumentTitle>
      )
    }
  }
}

export default withDocTitle
